import { render, staticRenderFns } from "./QrPaymentAlert.vue?vue&type=template&id=c5dd6fd2&scoped=true&"
import script from "./QrPaymentAlert.vue?vue&type=script&lang=js&"
export * from "./QrPaymentAlert.vue?vue&type=script&lang=js&"
import style0 from "./QrPaymentAlert.vue?vue&type=style&index=0&id=c5dd6fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dd6fd2",
  null
  
)

export default component.exports